import { render, staticRenderFns } from "./folderCreationComponent.vue?vue&type=template&id=a28c836e&"
import script from "./folderCreationComponent.vue?vue&type=script&lang=js&"
export * from "./folderCreationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports